import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { WalletBtns, WalletContainer, WalletHeader, WalletInputField } from "../walletStyles";
import { onInputAmount } from "../../../screens/dashboard/DashboardUtils";

const Amount = ({ context, amount, handleChange, title, onCloseModal, onProceed }) => {
	return (
		<WalletContainer>
			<>
				<WalletHeader headerText='Amount' onCloseModal={onCloseModal} context={context} />
				<Box sx={{ marginTop: 2 }} display='flex' flexDirection='column' gap={1}>
					<label htmlFor={title}>NGN</label>
					<WalletInputField
						name={title}
						onInput={onInputAmount}
						value={amount}
						onChange={handleChange}
						placeholder='Min Amount N100'
					/>
				</Box>
				<WalletBtns
					greenBtnClick={onProceed}
					whiteBtnClick={onCloseModal}
					isGreenBtnDisabled={Number(amount?.replaceAll(",", "")) < 100}
				/>
			</>
		</WalletContainer>
	);
};

export default Amount;

Amount.propTypes = {
	context: PropTypes.string,
	amount: PropTypes.string,
	handleChange: PropTypes.func,
	onCloseModal: PropTypes.func,
	onProceed: PropTypes.func,
	title: PropTypes.string,
};
